<template>
  <div class="accounting-document-summary-renderer">
    <span>{{ params.value }}</span></div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'AccountingDocumentSummaryRenderer',
  methods: {
    refresh() {
      return false
    }
  }
})
</script>

<style lang="scss">
.accounting-document-summary-renderer{
  height: 100%;
  .add-and-remove{
    position: absolute;
    width: 50px;
    height: 50px;
    left: -50px;
    border:1px solid #000;
    z-index: 99999;
  }
}
</style>
